export type ExperienceItem = {
    company: string;
    role: string;
    period: string;
    highlights: string[];
  };
  
  export type ProjectItem = {
    name: string;
    description: string;
    tech: string[];
    link?: string;
    repo?: string;
  };
  
  export const techStack: { title: string; items: string[] }[] = [
    { title: 'Languages', items: ['TypeScript', 'Java', 'Python'] },
    { title: 'Frameworks & Libraries', items: ['Node.js', 'Express', 'React', 'Spring Boot'] },
    { title: 'Databases & Messaging', items: ['PostgreSQL', 'MongoDB', 'Apache Kafka'] },
    { title: 'PM & Delivery', items: ['Agile', 'Roadmapping', 'Stakeholder Management', 'Risk Management'] },
  ];
  
  export const experience: ExperienceItem[] = [
    {
      company: 'Pervesk',
      role: 'Product Owner',
      period: 'Feb 2024 — Aug 2024',
      highlights: [
        'Delivered new features and bug fixes for mobile and web platforms',
        'Coordinated withg stakeholders',
        'Managed a small team of developers'
      ],
    },
    {
      company: 'Spectrocoin',
      role: 'Back-end Engineer',
      period: 'Oct 2023 — Feb 2024',
      highlights: [
        'Worked with Java and Spring framework',
        'Developed notification services using Apache Kafka.'
      ],
    },
    {
      company: 'Pervesk',
      role: 'Project manager',
      period: 'Jun 2021 — Oct 2023',
      highlights: [
        'Managed new features development',
        'Developed and maintained User API documentation',
        'Manual testing initial products',
        'Technical troubleshooting'
      ],
    },
    {
      company: 'Pervesk',
      role: 'Anti-money laundering specialist',
      period: 'Nov 2020 — Oct 2023',
      highlights: [
        'Developed an internal risk score automatic calculator.',
      ],
    },
  ];
  
  export const projects: ProjectItem[] = [
    {
      name: 'Paintings e-shop',
      description: 'Built a full-stack web application using a serverless architecture on AWS Lambda with Java for backend services. The frontend was developed in React with TypeScript, did not have any design, had to improvise. Integrated Stripe for payment processing. Created a back-office for listings management',
      tech: ['Java', 'React (TypeScript)', 'AWS Lambda', 'MySQL', 'Stripe', 'Google OAuth'],
      link: 'https://kavolis.com',
      repo: '',
    },
    {
      name: 'Old resume website',
      description: 'Built a resume web application in 2022 using React and TypeScript. Crafted custom CSS components from scratch without relying on UI libraries, aiming to deepen my understanding of styling and layout. Took inspiration from various online resources to design and implement features.',
      tech: ['React', 'TypeScript', 'CSS'],
      link: 'http://old.skripkauskas.lt'
    },
  ];
  
  export const contact = {
    email: 'rapolas.skripkauskas@gmail.com',
    linkedin: 'https://www.linkedin.com/in/rapolas-skripkauskas/',
    github: 'https://github.com/rapoliukstis',
    resume: '',
  };